module.exports = {
    contractarriveT:'您的合同即将到期',
    contContent:'温馨提示，您的合同即将到期，请及时联系您的商务负责人进行续签。',
    gotit:'我知道了',
    seeit:'立即查看',
    updatetitle:'您的素材已更新',
    updatenotice:'您有素材更新，详细请查看 素材界面链接',
    billtitle:'您的账单即将到期',
    billcontent:'温馨提示，您的账单即将到期，请查看并及时安排付款。',
    deletes:'删除',
    passed:'审核通过',
    unpassed:'审批中/审批不通过',

    Time:'时间',
    Invoice:'账单',
    Status:'状态',
    Operation:'操作',

    invoiceIm:'账单信息',
    contractIm: '合同信息',
    contractTime:'合同到期时间',
    contractAndInvoice:'合同和账单信息',
    notice_before:'经过沟通，很遗憾与贵方终止本次合作流程',
    notice_after:'，期待与您再次合作',
    off:'收起',
    open:'查看团队',
    expired:'已到期',
    unexpired:'未到期',
    jumptip:'跳转至合同详情页面',
    jumptip2:'跳转至账单详情页面',
    error:'地址解析错误',
    tracktitle:'网红业务进程提醒',
    closetitle:'网红业务进程终止提醒',
    trackcontent:'您有新流程更新，请注意查看',
    closecontent:'您有流程被终止，请注意查看',
    nofiles:'文件已被删除或已被取消发布',
    canread:'暂时无法在线预览'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/notification/zh-cn.js